import React from 'react';
import LogisticQuoteBasicInfoComponent from './logistics-quote-basic-info.component';
import LogisticsQuoteItemomponent from './logistics-quote-item.component';
import LogisticsQuoteAddressComponent from './logistics-quote-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const LogisticQuoteComponent = ({ handleInnerFormChange, quoteDetails, rowData, columnDefs, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Basic Info',
      component: <LogisticQuoteBasicInfoComponent
        quoteDetails={quoteDetails}
        handleInnerFormChange={handleInnerFormChange} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Quote Items',
      component: <LogisticsQuoteItemomponent
        quoteDetails={quoteDetails}
        rowData={rowData}
        columnDefs={columnDefs} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Address Details',
      component: <LogisticsQuoteAddressComponent
        quoteDetails={quoteDetails}
      />,
      isVisible: true,
    },

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-primary text-light rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        {/* <button
              className="m-2 bg-primary text-light rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
    
              type="submit"
            >
              Save
            </button> */}
      </div>
    </div>
  )
}
export default LogisticQuoteComponent;
